import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { detectEmbeddedPlatformLaunch } from '@blockbattle/platform-adapters';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AppErrorBoundary } from './components/AppErrorBoundary.js';
import { legacyEmbeddedRedirect, resolveAppEntry } from './app-entry.js';
import { applyPerformanceProfile } from './performance-profile.js';
import './styles.css';
import './dialog-layout.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, retry: 1 } },
});

const appEntry = resolveAppEntry(window.location.pathname);
applyPerformanceProfile(document.documentElement);
const legacyRedirect = appEntry
  ? null
  : legacyEmbeddedRedirect(
      window.location.pathname,
      detectEmbeddedPlatformLaunch(),
      window.location.search,
      window.location.hash,
    );

// Legacy MAX root links must also work when the asynchronous SDK arrives after React.
if (!appEntry && !legacyRedirect && window.location.pathname === '/') {
  document.getElementById('max-bridge')?.addEventListener(
    'load',
    () => {
      const redirect = legacyEmbeddedRedirect(
        window.location.pathname,
        detectEmbeddedPlatformLaunch(),
        window.location.search,
        window.location.hash,
      );
      if (redirect) window.location.replace(redirect);
    },
    { once: true },
  );
}

if (legacyRedirect) {
  window.location.replace(legacyRedirect);
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={appEntry?.basename ?? '/'}>
          <AppErrorBoundary>
            <App />
          </AppErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

import './game-atmosphere.css';
import './lobby-motion.css';
